// MARK://dhk8/admin-shell/lib/queries/modifiers
// Query tipada de grupos de modificadores — F1.3 / ADR-0009. El Admin lee los
// grupos por el grafo federado (subgraph catalog-modifiers), tenant del JWT (RLS),
// no por REST /v1/modifier-groups. F9.4: las escrituras (grupos/opciones/links) tambien por el grafo (mutations).
import { graphql } from '../../gql/index.js'

export const AdminModifierGroupsQuery = graphql(`
  query AdminModifierGroups($q: String, $limit: Int) {
    modifierGroups(q: $q, limit: $limit) {
      total
      items {
        id
        tenantId
        name
        minSelect
        maxSelect
        isRequired
        active
        createdAt
        updatedAt
        deletedAt
        productIds
        options {
          id
          groupId
          label
          priceDeltaCents
          nestedGroupId
          active
          sortOrder
        }
      }
    }
  }
`)


// ── F9.4: escrituras de modificadores por el grafo (tenant del JWT, RLS, IDOR-guard) ──
export const AdminCreateModifierGroupMutation = graphql(`
  mutation AdminCreateModifierGroup($input: ModifierGroupCreateInput!) {
    createModifierGroup(input: $input) {
      id
      tenantId
      name
      minSelect
      maxSelect
      isRequired
      active
      createdAt
      updatedAt
      deletedAt
      productIds
      options {
        id
        groupId
        label
        priceDeltaCents
        nestedGroupId
        active
        sortOrder
      }
    }
  }
`)

export const AdminUpdateModifierGroupMutation = graphql(`
  mutation AdminUpdateModifierGroup($id: ID!, $input: ModifierGroupUpdateInput!) {
    updateModifierGroup(id: $id, input: $input) {
      id
      tenantId
      name
      minSelect
      maxSelect
      isRequired
      active
      createdAt
      updatedAt
      deletedAt
      productIds
      options {
        id
        groupId
        label
        priceDeltaCents
        nestedGroupId
        active
        sortOrder
      }
    }
  }
`)

export const AdminDeleteModifierGroupMutation = graphql(`
  mutation AdminDeleteModifierGroup($id: ID!) {
    deleteModifierGroup(id: $id)
  }
`)

export const AdminAddModifierOptionMutation = graphql(`
  mutation AdminAddModifierOption($groupId: ID!, $input: ModifierOptionCreateInput!) {
    addModifierOption(groupId: $groupId, input: $input) {
      id
      groupId
      label
      priceDeltaCents
      nestedGroupId
      active
      sortOrder
    }
  }
`)

export const AdminUpdateModifierOptionMutation = graphql(`
  mutation AdminUpdateModifierOption($groupId: ID!, $optionId: ID!, $input: ModifierOptionUpdateInput!) {
    updateModifierOption(groupId: $groupId, optionId: $optionId, input: $input) {
      id
      groupId
      label
      priceDeltaCents
      nestedGroupId
      active
      sortOrder
    }
  }
`)

export const AdminRemoveModifierOptionMutation = graphql(`
  mutation AdminRemoveModifierOption($groupId: ID!, $optionId: ID!) {
    removeModifierOption(groupId: $groupId, optionId: $optionId)
  }
`)

export const AdminLinkModifierGroupToProductMutation = graphql(`
  mutation AdminLinkModifierGroupToProduct($groupId: ID!, $productId: ID!, $sortOrder: Int) {
    linkModifierGroupToProduct(groupId: $groupId, productId: $productId, sortOrder: $sortOrder)
  }
`)

export const AdminUnlinkModifierGroupFromProductMutation = graphql(`
  mutation AdminUnlinkModifierGroupFromProduct($groupId: ID!, $productId: ID!) {
    unlinkModifierGroupFromProduct(groupId: $groupId, productId: $productId)
  }
`)
